var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsDateString, IsInt, IsOptional, IsUUID, Min } from 'class-validator';
/**
 * Patient request for a *suggested batch* of slots against one of their own
 * treatment plans (PRD #1343, RS-004). Unlike the single-slot grid, this drives
 * the earliest-slots search: `count` slots honouring the plan's weekly
 * frequency, from `searchFrom`. The therapist, treatment, duration, weekly band
 * and office are all resolved server-side from the plan (continuity) — never
 * trusted from the client — and `count` is hard-capped at the plan's remaining
 * allowance server-side. A saturated calendar returns fewer than `count`
 * (partial availability); the caller states the shortfall.
 */
export class FindPatientBookingBatchDto {
    treatmentPlanId;
    /** How many appointments to suggest. Clamped to the plan's remaining allowance server-side. */
    count;
    /** Earliest day to search from (defaults to "today" server-side when omitted). */
    searchFrom;
    /**
     * Therapist preference (RS-007). Omitted → the plan's continuity therapist. A
     * specific id scopes the batch to that therapist; `anyTherapist` searches all
     * therapists ("egal", names dropped from the suggestion).
     */
    therapistId;
    anyTherapist;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FindPatientBookingBatchDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], FindPatientBookingBatchDto.prototype, "count", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], FindPatientBookingBatchDto.prototype, "searchFrom", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], FindPatientBookingBatchDto.prototype, "therapistId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FindPatientBookingBatchDto.prototype, "anyTherapist", void 0);
//# sourceMappingURL=find-patient-booking-batch.dto.js.map